export const COMPANY_BASE_SEARCH = [
  { title: "نام شرکت", value: "NAME" },
  { title: "نام کاربری", value: "USER_NAME" },
  { title: "شماره‌ همراه", value: "PHONE_NUMBER" },
  { title: "نام ", value: "FIRST_NAME" },
  { title: "نام خانوادگی", value: "LAST_NAME" },
];
export const MUNICIPALITY_BASE_SEARCH = [
  { title: "نام شهرداری", value: "NAME" },
  { title: "نام کاربری", value: "USER_NAME" },
  { title: "شماره‌ همراه", value: "PHONE_NUMBER" },
  { title: "نام ", value: "FIRST_NAME" },
  { title: "نام خانوادگی", value: "LAST_NAME" },
];
export const DRIVER_BASE_SEARCH = [
  { title: "نام", value: "FIRST_NAME" },
  { title: "نام خانوادگی", value: "LAST_NAME" },
  { title: "کدملی ", value: "NATIONAL_CODE" },
  { title: "شماره موبایل ", value: "PHONE_NUMBER" },
];
export const CLIENT_BASE_SEARCH = [
  { title: "نام", value: "firstName" },
  { title: "نام خانوادگی", value: "lastName" },
  { title: "شماره موبایل ", value: "phoneNumber" },
];

export const CATEGORY_BASE_SEARCH = [
  { title: "نام دسته بندی", value: "categoryName" },
];

export const TRANSACTION_BASE_SEARCH = [
  { title: "توضیحات", value: "description" },
];
export const Ticket_BASE_SEARCH = [{ title: "توضیحات", value: "description" }];
